import { useMemo } from 'react';

import { getMaxColumns, getValidColSpanValues } from '../constants/formLayout';

/**
 * Hook to get maximum columns configuration
 * Memoized to prevent unnecessary re-renders
 */
export const useMaxColumns = (): number => useMemo(() => getMaxColumns(), []);

/**
 * Hook to get valid colspan values for UI components
 */
export const useValidColSpanValues = (): number[] =>
  useMemo(() => getValidColSpanValues(), []);

/**
 * Hook to generate column span options for dropdowns
 */
export const useColumnSpanOptions = () => {
  const values = useValidColSpanValues();

  return useMemo(
    () =>
      values.map((value) => ({
        label: `${value} Column${value > 1 ? 's' : ''}`,
        value: String(value),
      })),
    [values]
  );
};

/**
 * Hook to check if a colSpan value needs migration
 */
export const useNeedsMigration = (colSpan: number): boolean => {
  const maxColumns = useMaxColumns();

  return useMemo(() => colSpan > maxColumns, [colSpan, maxColumns]);
};
